import { storeService } from "@/services/storeService";
import { CommonParams, STORES_QUERY_KEYS } from "@/types";
import { useInfiniteQuery } from "@tanstack/react-query";
import { useMemo } from "react";

export const useGetStoreMyUsers = (
  params?: CommonParams<{}> & {
    enabled?: boolean;
  }
) => {
  const { enabled = true, ...restParams } = params || {};

  const { data, fetchNextPage, hasNextPage, isFetching } = useInfiniteQuery({
    queryKey: [STORES_QUERY_KEYS.GET_STORE_MY_USERS, restParams],
    queryFn: async ({ pageParam = 1 }) =>
      storeService.getStoreMyUsers({
        page: pageParam,
        limit: 20,
        ...restParams,
      }),
    getNextPageParam: (lastPage) => {
      return lastPage.pagination?.hasNextPage
        ? lastPage.pagination.page + 1
        : undefined;
    },
    initialPageParam: 1,
    retry: 1,
    enabled,
  });

  const storeUsers = useMemo(() => {
    return (
      data?.pages
        .flatMap((page) => page.data)
        .map((user) => ({
          label: user.full_name || "",
          value: user.id,
          description: user.email || "",
        })) || []
    );
  }, [data]);

  return {
    storeUsers,
    fetchNextPage,
    hasNextPage,
    isFetching,
  };
};
